/**
 * Service d'encryptage centralisé
 * Utilise le service d'encryptage fourni par wab-config
 */
import { config } from '../config/environment.js';
import debug from '@commons-shared/debug.js';
import { post } from './api-router.js';

/**
 * Encrypte des données via le service wab-config
 * @param {any} data - Données à encrypter
 * @returns {Promise<string>} - Données encryptées
 */
export async function encryptData(data) {
  try {
    const response = await post('/api/config/encrypt-data', { value: data });
    
    if (!response.success || !response.result) {
      throw new Error(response.error || 'Failed to encrypt data');
    }
    
    return response.result;
  } catch (error) {
    debug.error(config, 'Encryption service error:', error);
    throw new Error(`Encryption failed: ${error.message}`);
  }
}

/**
 * Décrypte des données via le service wab-config
 * @param {string} encryptedData - Données encryptées
 * @returns {Promise<any>} - Données décryptées
 */
export async function decryptData(encryptedData) {
  try {
    const response = await post('/api/config/decrypt-data', { value: encryptedData });
    
    if (!response.success) {
      throw new Error(response.error || 'Failed to decrypt data');
    }
    
    return response.result;
  } catch (error) {
    debug.error(config, 'Decryption service error:', error);
    throw new Error(`Decryption failed: ${error.message}`);
  }
}

/**
 * Détecte si une chaîne est encryptée
 * @param {string} data - Chaîne à vérifier
 * @returns {boolean} - true si la chaîne semble encryptée
 */
export function isEncrypted(data) {
  if (!data || typeof data !== 'string') {
    return false;
  }
  
  // Vérification basique : données en base64 d'une certaine longueur
  const base64Regex = /^[A-Za-z0-9+/]+=*$/;
  return data.length > 50 && base64Regex.test(data);
}
